import styled from 'styled-components'

export const InfoIcon = styled.span`
  height: 22px;
  width: 22px;
  font-size: 18px;
  color: #fff;
  background-color: #7dd591;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  left: -10px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`

export const InfoWrapper = styled.div`
  width: 100%;
  padding: 23px;
  position: relative;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 21px;
`

export const InfoP = styled.p`
  margin: 0;
  font-weight: 500;
  text-align: center;
`
